import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, ConfigSettings } from '@shared/config';
import { DATA_API_URL } from '@data-api/config/data-api-url.config';
import { Observable } from 'rxjs';
import { GenericResponse } from '@data-api/models/generic-response/generic-response.model';
import { ShouldRefreshResponse } from '@data-api/models/should-refresh/should-refresh-response.model';

@Injectable()
export class CacheHttpService {
  private readonly dataApiUrl: string;

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) { dataApiUrl }: ConfigSettings
  ) {
    this.dataApiUrl = dataApiUrl;
  }

  public shouldRefresh(
    dataSourceId: string
  ): Observable<GenericResponse<ShouldRefreshResponse>> {
    return this.http.get<GenericResponse<ShouldRefreshResponse>>(
      `${this.dataApiUrl}${DATA_API_URL.shouldRefresh}`,
      {
        withCredentials: true,
        params: {
          dataSourceId,
        },
      }
    );
  }
}
